/**
 * Dicionário de termos jurídicos para identificação automática
 */

export interface LegalTermDefinition {
  term: string
  pattern: RegExp
  category: 'processual' | 'penal' | 'civel' | 'constitucional' | 'trabalhista' | 'geral'
  description: string
}

export const LEGAL_TERMS: LegalTermDefinition[] = [
  // ===============================================
  // TERMOS PROCESSUAIS GERAIS
  // ===============================================
  {
    term: 'audiência de instrução',
    pattern: /audiência\s+de\s+instrução/gi,
    category: 'processual',
    description: 'Audiência destinada à produção de provas, oitiva de testemunhas e interrogatório do réu.'
  },
  {
    term: 'audiência de custódia',
    pattern: /audiência\s+de\s+custódia/gi,
    category: 'processual',
    description: 'Audiência realizada em até 24h após a prisão em flagrante para verificar legalidade.'
  },
  {
    term: 'audiência de conciliação',
    pattern: /audiência\s+de\s+conciliação/gi,
    category: 'processual',
    description: 'Audiência destinada a tentativa de acordo entre as partes.'
  },
  {
    term: 'audiência una',
    pattern: /audiência\s+una/gi,
    category: 'processual',
    description: 'Audiência em que são realizados todos os atos processuais de instrução.'
  },
  {
    term: 'alegações finais',
    pattern: /alegações?\s+finais?/gi,
    category: 'processual',
    description: 'Manifestação das partes após a instrução processual, antes da sentença.'
  },
  {
    term: 'instrução processual',
    pattern: /instrução\s+(processual|criminal)?/gi,
    category: 'processual',
    description: 'Fase do processo destinada à colheita de provas.'
  },
  {
    term: 'oitiva',
    pattern: /\boitiva\b/gi,
    category: 'processual',
    description: 'Ato de ouvir testemunhas ou partes em juízo.'
  },
  {
    term: 'testemunha',
    pattern: /\btestemunhas?\b/gi,
    category: 'processual',
    description: 'Pessoa que presta depoimento sobre fatos de que tem conhecimento.'
  },
  {
    term: 'inquirição',
    pattern: /\binquirição\b/gi,
    category: 'processual',
    description: 'Ato de interrogar testemunhas ou partes.'
  },
  {
    term: 'contradita',
    pattern: /\bcontradita\b/gi,
    category: 'processual',
    description: 'Arguição de impedimento ou suspeição de testemunha.'
  },
  {
    term: 'sentença',
    pattern: /\bsentença\b/gi,
    category: 'processual',
    description: 'Decisão judicial que põe fim ao processo com resolução do mérito.'
  },
  {
    term: 'denúncia',
    pattern: /\bdenúncia\b/gi,
    category: 'processual',
    description: 'Peça inicial da ação penal pública, oferecida pelo Ministério Público.'
  },
  {
    term: 'queixa-crime',
    pattern: /queixa[\s-]?crime/gi,
    category: 'processual',
    description: 'Peça inicial da ação penal privada, oferecida pelo ofendido.'
  },
  {
    term: 'defesa',
    pattern: /\bdefesa\b/gi,
    category: 'processual',
    description: 'Conjunto de argumentos e provas apresentados em favor do réu.'
  },
  {
    term: 'defesa prévia',
    pattern: /defesa\s+prévia/gi,
    category: 'processual',
    description: 'Resposta à acusação apresentada antes do recebimento da denúncia.'
  },
  {
    term: 'resposta à acusação',
    pattern: /resposta\s+à\s+acusação/gi,
    category: 'processual',
    description: 'Peça de defesa apresentada após o recebimento da denúncia.'
  },
  {
    term: 'acusação',
    pattern: /\bacusação\b/gi,
    category: 'processual',
    description: 'Conjunto de argumentos e provas contra o réu.'
  },
  {
    term: 'autos',
    pattern: /\bautos\b/gi,
    category: 'processual',
    description: 'Conjunto de documentos que compõem o processo.'
  },
  {
    term: 'conclusos',
    pattern: /\bconclusos?\b/gi,
    category: 'processual',
    description: 'Autos encaminhados ao juiz para decisão.'
  },
  {
    term: 'apelação',
    pattern: /\bapelação\b/gi,
    category: 'processual',
    description: 'Recurso contra sentença de primeiro grau.'
  },
  {
    term: 'recurso',
    pattern: /\brecursos?\b/gi,
    category: 'processual',
    description: 'Meio de impugnação de decisões judiciais.'
  },
  {
    term: 'agravo',
    pattern: /\bagravo\b/gi,
    category: 'processual',
    description: 'Recurso contra decisões interlocutórias.'
  },
  {
    term: 'embargos',
    pattern: /\bembargos?\b/gi,
    category: 'processual',
    description: 'Recurso para esclarecimento ou modificação de decisão.'
  },
  {
    term: 'habeas corpus',
    pattern: /habeas\s+corpus/gi,
    category: 'processual',
    description: 'Ação constitucional para proteção da liberdade de locomoção.'
  },
  {
    term: 'mandado de segurança',
    pattern: /mandado\s+de\s+segurança/gi,
    category: 'processual',
    description: 'Ação constitucional para proteção de direito líquido e certo.'
  },
  {
    term: 'mandado',
    pattern: /mandado\s+(de\s+\w+)?/gi,
    category: 'processual',
    description: 'Ordem judicial escrita determinando a prática de um ato.'
  },
  {
    term: 'citação',
    pattern: /\bcitação\b/gi,
    category: 'processual',
    description: 'Ato pelo qual se chama o réu a juízo.'
  },
  {
    term: 'intimação',
    pattern: /\bintimação\b/gi,
    category: 'processual',
    description: 'Ato pelo qual se dá ciência de atos processuais.'
  },
  {
    term: 'notificação',
    pattern: /\bnotificação\b/gi,
    category: 'processual',
    description: 'Comunicação formal para ciência de ato ou decisão.'
  },
  {
    term: 'prazo',
    pattern: /\bprazos?\b/gi,
    category: 'processual',
    description: 'Período determinado para prática de atos processuais.'
  },
  {
    term: 'preclui',
    pattern: /\bpreclui\w*\b/gi,
    category: 'processual',
    description: 'Perda da faculdade de praticar ato processual pelo decurso do prazo.'
  },
  {
    term: 'decadência',
    pattern: /\bdecadência\b/gi,
    category: 'processual',
    description: 'Perda do direito de ação pelo decurso do tempo.'
  },
  {
    term: 'prescrição',
    pattern: /\bprescrição\b/gi,
    category: 'processual',
    description: 'Extinção da pretensão punitiva ou executória pelo decurso do tempo.'
  },
  {
    term: 'sustentação oral',
    pattern: /sustentação\s+oral/gi,
    category: 'processual',
    description: 'Exposição oral das razões do recurso perante o tribunal.'
  },
  {
    term: 'decisão interlocutória',
    pattern: /decisão\s+interlocutória/gi,
    category: 'processual',
    description: 'Decisão que resolve questão incidente sem pôr fim ao processo.'
  },
  {
    term: 'despacho',
    pattern: /\bdespacho\b/gi,
    category: 'processual',
    description: 'Ato judicial de mero expediente, sem conteúdo decisório.'
  },
  {
    term: 'acórdão',
    pattern: /\bacórdão\b/gi,
    category: 'processual',
    description: 'Decisão proferida por órgão colegiado de tribunal.'
  },
  {
    term: 'trânsito em julgado',
    pattern: /trânsito\s+em\s+julgado/gi,
    category: 'processual',
    description: 'Momento em que a decisão se torna definitiva e irrecorrível.'
  },
  {
    term: 'coisa julgada',
    pattern: /coisa\s+julgada/gi,
    category: 'processual',
    description: 'Qualidade da decisão judicial da qual não cabe mais recurso.'
  },
  {
    term: 'litispendência',
    pattern: /\blitispendência\b/gi,
    category: 'processual',
    description: 'Existência de ação idêntica já em curso.'
  },
  {
    term: 'revelia',
    pattern: /\brevelia\b/gi,
    category: 'processual',
    description: 'Situação do réu que não apresenta defesa no prazo.'
  },
  {
    term: 'tutela',
    pattern: /tutela\s+(antecipada|provisória|de\s+urgência)?/gi,
    category: 'processual',
    description: 'Medida judicial para proteção de direito antes da decisão final.'
  },
  {
    term: 'liminar',
    pattern: /\bliminar\b/gi,
    category: 'processual',
    description: 'Decisão provisória concedida no início do processo.'
  },
  {
    term: 'cautelar',
    pattern: /\bcautelar\b/gi,
    category: 'processual',
    description: 'Medida para assegurar a eficácia do processo principal.'
  },
  {
    term: 'petição inicial',
    pattern: /petição\s+inicial/gi,
    category: 'processual',
    description: 'Peça que inicia o processo judicial.'
  },
  {
    term: 'contestação',
    pattern: /\bcontestação\b/gi,
    category: 'processual',
    description: 'Peça de defesa do réu no processo civil.'
  },
  {
    term: 'réplica',
    pattern: /\bréplica\b/gi,
    category: 'processual',
    description: 'Manifestação do autor sobre a contestação.'
  },
  {
    term: 'parecer',
    pattern: /\bparecer\b/gi,
    category: 'processual',
    description: 'Manifestação opinativa do Ministério Público ou perito.'
  },
  {
    term: 'perícia',
    pattern: /\bperícia\b/gi,
    category: 'processual',
    description: 'Exame técnico realizado por especialista.'
  },
  {
    term: 'perito',
    pattern: /\bperitos?\b/gi,
    category: 'processual',
    description: 'Especialista que realiza exame técnico no processo.'
  },
  {
    term: 'laudo',
    pattern: /\blaudo\b/gi,
    category: 'processual',
    description: 'Documento contendo o resultado de perícia.'
  },
  {
    term: 'prova',
    pattern: /\bprovas?\b/gi,
    category: 'processual',
    description: 'Meio de demonstração da verdade dos fatos alegados.'
  },
  {
    term: 'ônus da prova',
    pattern: /ônus\s+da\s+prova/gi,
    category: 'processual',
    description: 'Encargo de provar os fatos alegados.'
  },
  {
    term: 'inversão do ônus',
    pattern: /inversão\s+do\s+ônus/gi,
    category: 'processual',
    description: 'Transferência do encargo de provar para a parte contrária.'
  },

  // ===============================================
  // TERMOS PENAIS / CRIMINAIS
  // ===============================================
  {
    term: 'flagrante',
    pattern: /flagrante\s*(delito)?/gi,
    category: 'penal',
    description: 'Prisão realizada no momento da prática do crime ou logo após.'
  },
  {
    term: 'prisão preventiva',
    pattern: /prisão\s+preventiva/gi,
    category: 'penal',
    description: 'Prisão cautelar decretada para garantia da ordem pública ou do processo.'
  },
  {
    term: 'prisão temporária',
    pattern: /prisão\s+temporária/gi,
    category: 'penal',
    description: 'Prisão cautelar durante a investigação de crimes graves.'
  },
  {
    term: 'prisão domiciliar',
    pattern: /prisão\s+domiciliar/gi,
    category: 'penal',
    description: 'Cumprimento de prisão na própria residência.'
  },
  {
    term: 'réu',
    pattern: /\bréu\b/gi,
    category: 'penal',
    description: 'Pessoa contra quem é movida a ação penal.'
  },
  {
    term: 'acusado',
    pattern: /\bacusados?\b/gi,
    category: 'penal',
    description: 'Pessoa formalmente denunciada em processo criminal.'
  },
  {
    term: 'indiciado',
    pattern: /\bindiciados?\b/gi,
    category: 'penal',
    description: 'Pessoa apontada como autora do crime no inquérito policial.'
  },
  {
    term: 'investigado',
    pattern: /\binvestigados?\b/gi,
    category: 'penal',
    description: 'Pessoa sob investigação criminal.'
  },
  {
    term: 'vítima',
    pattern: /\bvítimas?\b/gi,
    category: 'penal',
    description: 'Pessoa que sofreu a lesão decorrente do crime.'
  },
  {
    term: 'ofendido',
    pattern: /\bofendidos?\b/gi,
    category: 'penal',
    description: 'Pessoa cujo bem jurídico foi lesado pelo crime.'
  },
  {
    term: 'crime',
    pattern: /\bcrimes?\b/gi,
    category: 'penal',
    description: 'Conduta típica, ilícita e culpável.'
  },
  {
    term: 'delito',
    pattern: /\bdelitos?\b/gi,
    category: 'penal',
    description: 'Sinônimo de crime; infração penal.'
  },
  {
    term: 'contravenção',
    pattern: /\bcontravenção\b/gi,
    category: 'penal',
    description: 'Infração penal de menor potencial ofensivo.'
  },
  {
    term: 'tipicidade',
    pattern: /\btipicidade\b/gi,
    category: 'penal',
    description: 'Adequação da conduta ao tipo penal descrito em lei.'
  },
  {
    term: 'ilicitude',
    pattern: /\bilicitude\b/gi,
    category: 'penal',
    description: 'Contrariedade da conduta ao ordenamento jurídico.'
  },
  {
    term: 'culpabilidade',
    pattern: /\bculpabilidade\b/gi,
    category: 'penal',
    description: 'Juízo de reprovação sobre a conduta do agente.'
  },
  {
    term: 'dolo',
    pattern: /\bdolo\b/gi,
    category: 'penal',
    description: 'Vontade livre e consciente de praticar o crime.'
  },
  {
    term: 'culpa',
    pattern: /\bculpa\b/gi,
    category: 'penal',
    description: 'Violação do dever de cuidado (negligência, imprudência, imperícia).'
  },
  {
    term: 'negligência',
    pattern: /\bnegligência\b/gi,
    category: 'penal',
    description: 'Falta de cuidado por omissão.'
  },
  {
    term: 'imprudência',
    pattern: /\bimprudência\b/gi,
    category: 'penal',
    description: 'Falta de cuidado por ação precipitada.'
  },
  {
    term: 'imperícia',
    pattern: /\bimperícia\b/gi,
    category: 'penal',
    description: 'Falta de aptidão técnica para exercício de atividade.'
  },
  {
    term: 'legítima defesa',
    pattern: /legítima\s+defesa/gi,
    category: 'penal',
    description: 'Excludente de ilicitude para repelir injusta agressão.'
  },
  {
    term: 'estado de necessidade',
    pattern: /estado\s+de\s+necessidade/gi,
    category: 'penal',
    description: 'Excludente de ilicitude para salvar direito próprio ou alheio.'
  },
  {
    term: 'exercício regular',
    pattern: /exercício\s+regular\s+(de\s+direito|do\s+direito)/gi,
    category: 'penal',
    description: 'Excludente de ilicitude para atos permitidos por lei.'
  },
  {
    term: 'estrito cumprimento',
    pattern: /estrito\s+cumprimento\s+(do\s+dever)?/gi,
    category: 'penal',
    description: 'Excludente de ilicitude para atos praticados no dever funcional.'
  },
  {
    term: 'excludente',
    pattern: /\bexcludente\b/gi,
    category: 'penal',
    description: 'Causa que afasta a ilicitude ou culpabilidade.'
  },
  {
    term: 'atenuante',
    pattern: /\batenuantes?\b/gi,
    category: 'penal',
    description: 'Circunstância que diminui a pena.'
  },
  {
    term: 'agravante',
    pattern: /\bagravantes?\b/gi,
    category: 'penal',
    description: 'Circunstância que aumenta a pena.'
  },
  {
    term: 'qualificadora',
    pattern: /\bqualificadoras?\b/gi,
    category: 'penal',
    description: 'Circunstância que torna o crime mais grave.'
  },
  {
    term: 'majorante',
    pattern: /\bmajorantes?\b/gi,
    category: 'penal',
    description: 'Causa de aumento de pena.'
  },
  {
    term: 'minorante',
    pattern: /\bminorantes?\b/gi,
    category: 'penal',
    description: 'Causa de diminuição de pena.'
  },
  {
    term: 'privilegiadora',
    pattern: /\bprivilegiadora\b/gi,
    category: 'penal',
    description: 'Circunstância que torna o crime menos grave.'
  },
  {
    term: 'falso testemunho',
    pattern: /falso\s+testemunho/gi,
    category: 'penal',
    description: 'Crime previsto no art. 342 do CP: fazer afirmação falsa em processo.'
  },
  {
    term: 'prisão',
    pattern: /\bprisão\b/gi,
    category: 'penal',
    description: 'Restrição da liberdade de locomoção.'
  },
  {
    term: 'apreensão',
    pattern: /\bapreensão\b/gi,
    category: 'penal',
    description: 'Ato de recolher objetos relacionados ao crime.'
  },
  {
    term: 'abordagem',
    pattern: /\babordagem\b/gi,
    category: 'penal',
    description: 'Ação policial de verificação de pessoa ou veículo.'
  },
  {
    term: 'busca e apreensão',
    pattern: /busca\s+e\s+apreensão/gi,
    category: 'penal',
    description: 'Diligência para localizar e recolher pessoas ou coisas.'
  },
  {
    term: 'tráfico',
    pattern: /\btráfico\b/gi,
    category: 'penal',
    description: 'Crime de comércio ilegal de drogas ou pessoas.'
  },
  {
    term: 'drogas',
    pattern: /\b(?:drogas?|entorpecentes?|substância\s+análoga)\b/gi,
    category: 'penal',
    description: 'Substâncias ilícitas sujeitas a controle especial.'
  },
  {
    term: 'pena',
    pattern: /\bpena\b/gi,
    category: 'penal',
    description: 'Sanção imposta pelo Estado ao autor de crime.'
  },
  {
    term: 'regime fechado',
    pattern: /regime\s+fechado/gi,
    category: 'penal',
    description: 'Cumprimento de pena em estabelecimento de segurança máxima.'
  },
  {
    term: 'regime semiaberto',
    pattern: /regime\s+semiaberto/gi,
    category: 'penal',
    description: 'Cumprimento de pena em colônia agrícola ou industrial.'
  },
  {
    term: 'regime aberto',
    pattern: /regime\s+aberto/gi,
    category: 'penal',
    description: 'Cumprimento de pena em casa de albergado.'
  },
  {
    term: 'progressão de regime',
    pattern: /progressão\s+de\s+regime/gi,
    category: 'penal',
    description: 'Passagem de regime mais rigoroso para menos rigoroso.'
  },
  {
    term: 'regressão de regime',
    pattern: /regressão\s+de\s+regime/gi,
    category: 'penal',
    description: 'Retorno a regime mais rigoroso por falta grave.'
  },
  {
    term: 'livramento condicional',
    pattern: /livramento\s+condicional/gi,
    category: 'penal',
    description: 'Antecipação da liberdade mediante condições.'
  },
  {
    term: 'sursis',
    pattern: /\bsursis\b/gi,
    category: 'penal',
    description: 'Suspensão condicional da pena.'
  },
  {
    term: 'suspensão condicional',
    pattern: /suspensão\s+condicional/gi,
    category: 'penal',
    description: 'Benefício que suspende a execução da pena.'
  },
  {
    term: 'transação penal',
    pattern: /transação\s+penal/gi,
    category: 'penal',
    description: 'Acordo para aplicação de pena alternativa em crimes menores.'
  },
  {
    term: 'suspensão do processo',
    pattern: /suspensão\s+do\s+processo|suspensão\s+condicional\s+do\s+processo/gi,
    category: 'penal',
    description: 'Benefício que suspende o andamento do processo penal.'
  },
  {
    term: 'medida cautelar',
    pattern: /medida\s+cautelar/gi,
    category: 'penal',
    description: 'Medida restritiva alternativa à prisão preventiva.'
  },
  {
    term: 'monitoramento eletrônico',
    pattern: /monitoramento\s+eletrônico|tornozeleira/gi,
    category: 'penal',
    description: 'Fiscalização do condenado por dispositivo eletrônico.'
  },
  {
    term: 'fiança',
    pattern: /\bfiança\b/gi,
    category: 'penal',
    description: 'Caução prestada para assegurar a liberdade provisória.'
  },
  {
    term: 'liberdade provisória',
    pattern: /liberdade\s+provisória/gi,
    category: 'penal',
    description: 'Liberdade concedida durante o processo mediante condições.'
  },
  {
    term: 'relaxamento',
    pattern: /\brelaxamento\b/gi,
    category: 'penal',
    description: 'Liberação por ilegalidade da prisão.'
  },
  {
    term: 'revogação',
    pattern: /\brevogação\b/gi,
    category: 'penal',
    description: 'Cancelamento de decisão anterior.'
  },
  {
    term: 'homicídio',
    pattern: /\bhomicídio\b/gi,
    category: 'penal',
    description: 'Crime de matar alguém (art. 121 CP).'
  },
  {
    term: 'lesão corporal',
    pattern: /lesão\s+corporal/gi,
    category: 'penal',
    description: 'Crime de ofender a integridade física de outrem (art. 129 CP).'
  },
  {
    term: 'roubo',
    pattern: /\broubo\b/gi,
    category: 'penal',
    description: 'Crime de subtrair coisa mediante violência ou grave ameaça (art. 157 CP).'
  },
  {
    term: 'furto',
    pattern: /\bfurto\b/gi,
    category: 'penal',
    description: 'Crime de subtrair coisa alheia móvel (art. 155 CP).'
  },
  {
    term: 'latrocínio',
    pattern: /\blatrocínio\b/gi,
    category: 'penal',
    description: 'Roubo seguido de morte.'
  },
  {
    term: 'extorsão',
    pattern: /\bextorsão\b/gi,
    category: 'penal',
    description: 'Crime de constranger para obter vantagem (art. 158 CP).'
  },
  {
    term: 'estelionato',
    pattern: /\bestelionato\b/gi,
    category: 'penal',
    description: 'Crime de obter vantagem mediante fraude (art. 171 CP).'
  },
  {
    term: 'estupro',
    pattern: /\bestupro\b/gi,
    category: 'penal',
    description: 'Crime contra a dignidade sexual (art. 213 CP).'
  },
  {
    term: 'ameaça',
    pattern: /\bameaça\b/gi,
    category: 'penal',
    description: 'Crime de intimidar alguém prometendo mal (art. 147 CP).'
  },
  {
    term: 'injúria',
    pattern: /\binjúria\b/gi,
    category: 'penal',
    description: 'Crime contra a honra subjetiva (art. 140 CP).'
  },
  {
    term: 'calúnia',
    pattern: /\bcalúnia\b/gi,
    category: 'penal',
    description: 'Imputar falsamente crime a alguém (art. 138 CP).'
  },
  {
    term: 'difamação',
    pattern: /\bdifamação\b/gi,
    category: 'penal',
    description: 'Imputar fato ofensivo à reputação (art. 139 CP).'
  },
  {
    term: 'receptação',
    pattern: /\breceptação\b/gi,
    category: 'penal',
    description: 'Crime de adquirir produto de crime (art. 180 CP).'
  },
  {
    term: 'associação criminosa',
    pattern: /associação\s+criminosa/gi,
    category: 'penal',
    description: 'Crime de associar-se para cometer crimes (art. 288 CP).'
  },
  {
    term: 'organização criminosa',
    pattern: /organização\s+criminosa/gi,
    category: 'penal',
    description: 'Associação de 4 ou mais pessoas para crimes graves (Lei 12.850/13).'
  },
  {
    term: 'lavagem de dinheiro',
    pattern: /lavagem\s+de\s+dinheiro/gi,
    category: 'penal',
    description: 'Crime de ocultar bens provenientes de crime (Lei 9.613/98).'
  },
  {
    term: 'corrupção',
    pattern: /\bcorrupção\b/gi,
    category: 'penal',
    description: 'Crime contra a administração pública (arts. 317, 333 CP).'
  },
  {
    term: 'peculato',
    pattern: /\bpeculato\b/gi,
    category: 'penal',
    description: 'Apropriação de bem público por funcionário (art. 312 CP).'
  },
  {
    term: 'concussão',
    pattern: /\bconcussão\b/gi,
    category: 'penal',
    description: 'Exigir vantagem indevida em razão da função (art. 316 CP).'
  },
  {
    term: 'prevaricação',
    pattern: /\bprevaricação\b/gi,
    category: 'penal',
    description: 'Retardar ou deixar de praticar ato de ofício (art. 319 CP).'
  },
  {
    term: 'inquérito policial',
    pattern: /inquérito\s+policial/gi,
    category: 'penal',
    description: 'Procedimento investigatório conduzido pela polícia.'
  },
  {
    term: 'inquérito',
    pattern: /\binquérito\b/gi,
    category: 'penal',
    description: 'Procedimento de investigação criminal.'
  },
  {
    term: 'delegado',
    pattern: /\bdelegados?\b/gi,
    category: 'penal',
    description: 'Autoridade policial que preside o inquérito.'
  },
  {
    term: 'boletim de ocorrência',
    pattern: /boletim\s+de\s+ocorrência|B\.?O\.?/gi,
    category: 'penal',
    description: 'Documento que registra a notícia de crime.'
  },
  {
    term: 'auto de prisão',
    pattern: /auto\s+de\s+prisão/gi,
    category: 'penal',
    description: 'Documento formal que registra a prisão em flagrante.'
  },
  {
    term: 'exame de corpo de delito',
    pattern: /exame\s+de\s+corpo\s+de\s+delito/gi,
    category: 'penal',
    description: 'Perícia sobre vestígios materiais do crime.'
  },
  {
    term: 'materialidade',
    pattern: /\bmaterialidade\b/gi,
    category: 'penal',
    description: 'Prova da existência do crime.'
  },
  {
    term: 'autoria',
    pattern: /\bautoria\b/gi,
    category: 'penal',
    description: 'Identificação de quem praticou o crime.'
  },
  {
    term: 'indícios',
    pattern: /\bindícios?\b/gi,
    category: 'penal',
    description: 'Circunstâncias que permitem concluir pela existência de fato.'
  },
  {
    term: 'confissão',
    pattern: /\bconfissão\b/gi,
    category: 'penal',
    description: 'Admissão pelo réu da autoria do crime.'
  },
  {
    term: 'delação',
    pattern: /\bdelação\b/gi,
    category: 'penal',
    description: 'Revelação de informações sobre outros criminosos.'
  },
  {
    term: 'colaboração premiada',
    pattern: /colaboração\s+premiada/gi,
    category: 'penal',
    description: 'Acordo de cooperação com benefícios ao delator.'
  },
  {
    term: 'absolvição',
    pattern: /\babsolvição\b/gi,
    category: 'penal',
    description: 'Decisão que julga improcedente a acusação.'
  },
  {
    term: 'condenação',
    pattern: /\bcondenação\b/gi,
    category: 'penal',
    description: 'Decisão que julga procedente a acusação.'
  },
  {
    term: 'reincidência',
    pattern: /\breincidência\b/gi,
    category: 'penal',
    description: 'Prática de novo crime após condenação definitiva anterior.'
  },
  {
    term: 'maus antecedentes',
    pattern: /maus\s+antecedentes/gi,
    category: 'penal',
    description: 'Histórico criminal que não configura reincidência.'
  },
  {
    term: 'dosimetria',
    pattern: /\bdosimetria\b/gi,
    category: 'penal',
    description: 'Cálculo da pena segundo critérios legais.'
  },
  {
    term: 'pena-base',
    pattern: /pena[\s-]?base/gi,
    category: 'penal',
    description: 'Primeira fase da dosimetria da pena.'
  },
  {
    term: 'concurso de crimes',
    pattern: /concurso\s+de\s+crimes/gi,
    category: 'penal',
    description: 'Prática de dois ou mais crimes.'
  },
  {
    term: 'crime continuado',
    pattern: /crime\s+continuado/gi,
    category: 'penal',
    description: 'Crimes da mesma espécie em continuidade delitiva.'
  },
  {
    term: 'tentativa',
    pattern: /\btentativa\b/gi,
    category: 'penal',
    description: 'Crime iniciado mas não consumado.'
  },
  {
    term: 'consumação',
    pattern: /\bconsumação\b/gi,
    category: 'penal',
    description: 'Realização completa do tipo penal.'
  },
  {
    term: 'coautoria',
    pattern: /\bcoautoria\b/gi,
    category: 'penal',
    description: 'Prática conjunta do crime por duas ou mais pessoas.'
  },
  {
    term: 'partícipe',
    pattern: /\bpartícipes?\b/gi,
    category: 'penal',
    description: 'Pessoa que colabora com o crime sem executá-lo.'
  },
  {
    term: 'júri',
    pattern: /\bjúri\b/gi,
    category: 'penal',
    description: 'Tribunal popular que julga crimes dolosos contra a vida.'
  },
  {
    term: 'pronúncia',
    pattern: /\bpronúncia\b/gi,
    category: 'penal',
    description: 'Decisão que submete o réu a julgamento pelo júri.'
  },
  {
    term: 'impronúncia',
    pattern: /\bimpronúncia\b/gi,
    category: 'penal',
    description: 'Decisão que não remete o réu ao júri por falta de provas.'
  },
  {
    term: 'desclassificação',
    pattern: /\bdesclassificação\b/gi,
    category: 'penal',
    description: 'Reconhecimento de crime diverso do denunciado.'
  },
  {
    term: 'quesito',
    pattern: /\bquesitos?\b/gi,
    category: 'penal',
    description: 'Pergunta formulada aos jurados no tribunal do júri.'
  },

  // ===============================================
  // TERMOS CÍVEIS
  // ===============================================
  {
    term: 'autor',
    pattern: /\bautora?\b/gi,
    category: 'civel',
    description: 'Parte que propõe a ação judicial.'
  },
  {
    term: 'réu civil',
    pattern: /\bréu\b/gi,
    category: 'civel',
    description: 'Parte contra quem é proposta a ação civil.'
  },
  {
    term: 'litígio',
    pattern: /\blitígio\b/gi,
    category: 'civel',
    description: 'Conflito de interesses submetido ao Judiciário.'
  },
  {
    term: 'lide',
    pattern: /\blide\b/gi,
    category: 'civel',
    description: 'Conflito de interesses qualificado por uma pretensão resistida.'
  },
  {
    term: 'dano moral',
    pattern: /dano\s+moral/gi,
    category: 'civel',
    description: 'Lesão a direito da personalidade.'
  },
  {
    term: 'dano material',
    pattern: /dano\s+material/gi,
    category: 'civel',
    description: 'Prejuízo econômico efetivo.'
  },
  {
    term: 'dano estético',
    pattern: /dano\s+estético/gi,
    category: 'civel',
    description: 'Lesão que afeta a aparência física da pessoa.'
  },
  {
    term: 'lucros cessantes',
    pattern: /lucros\s+cessantes/gi,
    category: 'civel',
    description: 'Ganhos que deixaram de ser obtidos por causa do dano.'
  },
  {
    term: 'danos emergentes',
    pattern: /danos\s+emergentes/gi,
    category: 'civel',
    description: 'Prejuízos efetivamente sofridos.'
  },
  {
    term: 'indenização',
    pattern: /\bindenização\b/gi,
    category: 'civel',
    description: 'Reparação pecuniária por danos sofridos.'
  },
  {
    term: 'responsabilidade civil',
    pattern: /responsabilidade\s+civil/gi,
    category: 'civel',
    description: 'Dever de reparar danos causados a outrem.'
  },
  {
    term: 'responsabilidade objetiva',
    pattern: /responsabilidade\s+objetiva/gi,
    category: 'civel',
    description: 'Responsabilidade independente de culpa.'
  },
  {
    term: 'responsabilidade subjetiva',
    pattern: /responsabilidade\s+subjetiva/gi,
    category: 'civel',
    description: 'Responsabilidade que depende de culpa.'
  },
  {
    term: 'nexo causal',
    pattern: /nexo\s+causal/gi,
    category: 'civel',
    description: 'Relação de causa e efeito entre conduta e dano.'
  },
  {
    term: 'solidariedade',
    pattern: /\bsolidariedade\b/gi,
    category: 'civel',
    description: 'Obrigação em que cada devedor responde pela totalidade.'
  },
  {
    term: 'obrigação',
    pattern: /\bobrigação\b/gi,
    category: 'civel',
    description: 'Vínculo jurídico que impõe prestação a uma parte.'
  },
  {
    term: 'contrato',
    pattern: /\bcontrato\b/gi,
    category: 'civel',
    description: 'Acordo de vontades que cria obrigações.'
  },
  {
    term: 'rescisão',
    pattern: /\brescisão\b/gi,
    category: 'civel',
    description: 'Extinção do contrato por inexecução.'
  },
  {
    term: 'resolução contratual',
    pattern: /resolução\s+(contratual|do\s+contrato)/gi,
    category: 'civel',
    description: 'Extinção do contrato por inadimplemento.'
  },
  {
    term: 'inadimplemento',
    pattern: /\binadimplemento\b/gi,
    category: 'civel',
    description: 'Descumprimento de obrigação contratual.'
  },
  {
    term: 'mora',
    pattern: /\bmora\b/gi,
    category: 'civel',
    description: 'Atraso no cumprimento da obrigação.'
  },
  {
    term: 'cláusula penal',
    pattern: /cláusula\s+penal/gi,
    category: 'civel',
    description: 'Multa estipulada para caso de descumprimento.'
  },
  {
    term: 'multa contratual',
    pattern: /multa\s+contratual/gi,
    category: 'civel',
    description: 'Penalidade por descumprimento de contrato.'
  },
  {
    term: 'juros',
    pattern: /\bjuros\b/gi,
    category: 'civel',
    description: 'Remuneração pelo uso do capital.'
  },
  {
    term: 'correção monetária',
    pattern: /correção\s+monetária/gi,
    category: 'civel',
    description: 'Atualização do valor pela inflação.'
  },
  {
    term: 'consignação em pagamento',
    pattern: /consignação\s+em\s+pagamento/gi,
    category: 'civel',
    description: 'Depósito judicial para liberar devedor.'
  },
  {
    term: 'usucapião',
    pattern: /\busucapião\b/gi,
    category: 'civel',
    description: 'Aquisição de propriedade pela posse prolongada.'
  },
  {
    term: 'posse',
    pattern: /\bposse\b/gi,
    category: 'civel',
    description: 'Exercício de fato de poderes sobre a coisa.'
  },
  {
    term: 'propriedade',
    pattern: /\bpropriedade\b/gi,
    category: 'civel',
    description: 'Direito de usar, gozar, dispor e reaver a coisa.'
  },
  {
    term: 'reintegração de posse',
    pattern: /reintegração\s+de\s+posse/gi,
    category: 'civel',
    description: 'Ação para recuperar posse perdida.'
  },
  {
    term: 'manutenção de posse',
    pattern: /manutenção\s+de\s+posse/gi,
    category: 'civel',
    description: 'Ação para defender posse turbada.'
  },
  {
    term: 'interdito proibitório',
    pattern: /interdito\s+proibitório/gi,
    category: 'civel',
    description: 'Ação preventiva para evitar turbação ou esbulho.'
  },
  {
    term: 'esbulho',
    pattern: /\besbulho\b/gi,
    category: 'civel',
    description: 'Perda total da posse por ato de terceiro.'
  },
  {
    term: 'turbação',
    pattern: /\bturbação\b/gi,
    category: 'civel',
    description: 'Perturbação do exercício da posse.'
  },
  {
    term: 'despejo',
    pattern: /\bdespejo\b/gi,
    category: 'civel',
    description: 'Ação para desocupação de imóvel locado.'
  },
  {
    term: 'locação',
    pattern: /\blocação\b/gi,
    category: 'civel',
    description: 'Contrato de aluguel de coisa.'
  },
  {
    term: 'locador',
    pattern: /\blocador\b/gi,
    category: 'civel',
    description: 'Proprietário que cede a coisa em locação.'
  },
  {
    term: 'locatário',
    pattern: /\blocatário\b/gi,
    category: 'civel',
    description: 'Pessoa que recebe a coisa em locação.'
  },
  {
    term: 'alimentos',
    pattern: /\balimentos\b/gi,
    category: 'civel',
    description: 'Prestação para suprir necessidades vitais.'
  },
  {
    term: 'pensão alimentícia',
    pattern: /pensão\s+alimentícia/gi,
    category: 'civel',
    description: 'Valor pago para sustento de dependente.'
  },
  {
    term: 'guarda',
    pattern: /\bguarda\b/gi,
    category: 'civel',
    description: 'Responsabilidade pelos cuidados de menor.'
  },
  {
    term: 'guarda compartilhada',
    pattern: /guarda\s+compartilhada/gi,
    category: 'civel',
    description: 'Divisão da responsabilidade entre os pais.'
  },
  {
    term: 'divórcio',
    pattern: /\bdivórcio\b/gi,
    category: 'civel',
    description: 'Dissolução do casamento civil.'
  },
  {
    term: 'separação',
    pattern: /\bseparação\b/gi,
    category: 'civel',
    description: 'Extinção dos deveres conjugais.'
  },
  {
    term: 'partilha',
    pattern: /\bpartilha\b/gi,
    category: 'civel',
    description: 'Divisão de bens entre os cônjuges ou herdeiros.'
  },
  {
    term: 'inventário',
    pattern: /\binventário\b/gi,
    category: 'civel',
    description: 'Procedimento para apuração e divisão de herança.'
  },
  {
    term: 'herança',
    pattern: /\bherança\b/gi,
    category: 'civel',
    description: 'Patrimônio transmitido por causa da morte.'
  },
  {
    term: 'herdeiro',
    pattern: /\bherdeiros?\b/gi,
    category: 'civel',
    description: 'Pessoa que recebe a herança.'
  },
  {
    term: 'testamento',
    pattern: /\btestamento\b/gi,
    category: 'civel',
    description: 'Ato pelo qual alguém dispõe de bens para após a morte.'
  },
  {
    term: 'legítima',
    pattern: /\blegítima\b/gi,
    category: 'civel',
    description: 'Parte da herança reservada aos herdeiros necessários.'
  },
  {
    term: 'execução',
    pattern: /\bexecução\b/gi,
    category: 'civel',
    description: 'Processo para cumprimento forçado de obrigação.'
  },
  {
    term: 'penhora',
    pattern: /\bpenhora\b/gi,
    category: 'civel',
    description: 'Apreensão de bens do devedor para garantir pagamento.'
  },
  {
    term: 'arresto',
    pattern: /\barresto\b/gi,
    category: 'civel',
    description: 'Apreensão cautelar de bens indeterminados.'
  },
  {
    term: 'sequestro de bens',
    pattern: /sequestro\s+de\s+bens/gi,
    category: 'civel',
    description: 'Apreensão cautelar de bem determinado.'
  },
  {
    term: 'hasta pública',
    pattern: /hasta\s+pública/gi,
    category: 'civel',
    description: 'Leilão judicial de bens penhorados.'
  },
  {
    term: 'leilão',
    pattern: /\bleilão\b/gi,
    category: 'civel',
    description: 'Venda pública de bens ao maior lance.'
  },
  {
    term: 'precatório',
    pattern: /\bprecatório\b/gi,
    category: 'civel',
    description: 'Requisição de pagamento de dívida da Fazenda Pública.'
  },
  {
    term: 'compensação',
    pattern: /\bcompensação\b/gi,
    category: 'civel',
    description: 'Extinção de obrigações recíprocas.'
  },
  {
    term: 'novação',
    pattern: /\bnovação\b/gi,
    category: 'civel',
    description: 'Substituição de obrigação anterior por nova.'
  },
  {
    term: 'cessão',
    pattern: /\bcessão\b/gi,
    category: 'civel',
    description: 'Transferência de direito ou crédito a terceiro.'
  },
  {
    term: 'sub-rogação',
    pattern: /sub[\s-]?rogação/gi,
    category: 'civel',
    description: 'Transferência de direitos ao terceiro que paga a dívida.'
  },

  // ===============================================
  // PARTICIPANTES/CARGOS
  // ===============================================
  {
    term: 'Ministério Público',
    pattern: /\b(?:ministério\s+público|MP)\b/gi,
    category: 'geral',
    description: 'Órgão responsável pela acusação em ações penais públicas.'
  },
  {
    term: 'Juiz',
    pattern: /\b(?:juiz|juíza|meritíssimo|excelência)\b/gi,
    category: 'geral',
    description: 'Magistrado responsável por conduzir o processo e proferir decisões.'
  },
  {
    term: 'Promotor',
    pattern: /\b(?:promotor|promotora)\b/gi,
    category: 'geral',
    description: 'Membro do Ministério Público.'
  },
  {
    term: 'Procurador',
    pattern: /\b(?:procurador|procuradora)\b/gi,
    category: 'geral',
    description: 'Membro do MP ou representante do ente público.'
  },
  {
    term: 'Advogado',
    pattern: /\b(?:advogados?|defensor)\b/gi,
    category: 'geral',
    description: 'Profissional habilitado a representar partes em juízo.'
  },
  {
    term: 'Defensoria Pública',
    pattern: /defensoria\s+pública/gi,
    category: 'geral',
    description: 'Órgão que presta assistência jurídica gratuita.'
  },
  {
    term: 'Defensor Público',
    pattern: /defensor\s+público/gi,
    category: 'geral',
    description: 'Membro da Defensoria Pública.'
  },
  {
    term: 'Desembargador',
    pattern: /\b(?:desembargador|desembargadora)\b/gi,
    category: 'geral',
    description: 'Magistrado de segundo grau (Tribunal de Justiça).'
  },
  {
    term: 'Ministro',
    pattern: /\b(?:ministro|ministra)\b/gi,
    category: 'geral',
    description: 'Magistrado dos Tribunais Superiores.'
  },
  {
    term: 'Relator',
    pattern: /\b(?:relator|relatora)\b/gi,
    category: 'geral',
    description: 'Desembargador/Ministro responsável por analisar e apresentar o recurso.'
  },
  {
    term: 'Revisor',
    pattern: /\b(?:revisor|revisora)\b/gi,
    category: 'geral',
    description: 'Membro do órgão colegiado que revisa o voto do relator.'
  },
  {
    term: 'Escrivão',
    pattern: /\b(?:escrivão|escrivã)\b/gi,
    category: 'geral',
    description: 'Servidor responsável por documentar atos processuais.'
  },
  {
    term: 'Oficial de Justiça',
    pattern: /oficial\s+de\s+justiça/gi,
    category: 'geral',
    description: 'Servidor responsável por cumprir mandados judiciais.'
  },
  {
    term: 'Assistente de acusação',
    pattern: /assistente\s+de\s+acusação/gi,
    category: 'geral',
    description: 'Ofendido que auxilia o MP na ação penal pública.'
  },
  {
    term: 'Curador',
    pattern: /\bcurador\b/gi,
    category: 'geral',
    description: 'Pessoa nomeada para zelar pelos interesses de incapaz.'
  },

  // ===============================================
  // REFERÊNCIAS LEGAIS
  // ===============================================
  {
    term: 'Código de Processo Penal',
    pattern: /código\s+de\s+processo\s+penal|CPP/gi,
    category: 'processual',
    description: 'Decreto-Lei 3.689/1941 - regula o processo penal brasileiro.'
  },
  {
    term: 'Código Penal',
    pattern: /código\s+penal|CP/gi,
    category: 'penal',
    description: 'Decreto-Lei 2.848/1940 - define crimes e penas.'
  },
  {
    term: 'Código Civil',
    pattern: /código\s+civil|CC/gi,
    category: 'civel',
    description: 'Lei 10.406/2002 - regula relações privadas.'
  },
  {
    term: 'Código de Processo Civil',
    pattern: /código\s+de\s+processo\s+civil|CPC/gi,
    category: 'civel',
    description: 'Lei 13.105/2015 - regula o processo civil.'
  },
  {
    term: 'Constituição Federal',
    pattern: /constituição\s+federal|CF/gi,
    category: 'constitucional',
    description: 'Lei máxima do país, promulgada em 1988.'
  },
  {
    term: 'Lei de Execução Penal',
    pattern: /lei\s+de\s+execução\s+penal|LEP/gi,
    category: 'penal',
    description: 'Lei 7.210/1984 - regula a execução da pena.'
  },
  {
    term: 'Lei de Drogas',
    pattern: /lei\s+de\s+drogas/gi,
    category: 'penal',
    description: 'Lei 11.343/2006 - repressão ao tráfico de drogas.'
  },
  {
    term: 'Lei Maria da Penha',
    pattern: /lei\s+maria\s+da\s+penha/gi,
    category: 'penal',
    description: 'Lei 11.340/2006 - violência doméstica contra a mulher.'
  },
  {
    term: 'Estatuto da Criança',
    pattern: /estatuto\s+da\s+criança|ECA/gi,
    category: 'penal',
    description: 'Lei 8.069/1990 - proteção integral à criança e adolescente.'
  },
  {
    term: 'Código de Defesa do Consumidor',
    pattern: /código\s+de\s+defesa\s+do\s+consumidor|CDC/gi,
    category: 'civel',
    description: 'Lei 8.078/1990 - proteção ao consumidor.'
  },
  {
    term: 'artigo',
    pattern: /artigos?\s+\d+|art\.\s*\d+/gi,
    category: 'geral',
    description: 'Dispositivo legal específico de uma lei ou código.'
  },
  {
    term: 'parágrafo',
    pattern: /parágrafos?\s*(único|\d+)|§\s*\d+/gi,
    category: 'geral',
    description: 'Subdivisão de artigo de lei.'
  },
  {
    term: 'inciso',
    pattern: /incisos?\s+[IVXLCDM]+/gi,
    category: 'geral',
    description: 'Subdivisão de artigo ou parágrafo.'
  },
  {
    term: 'alínea',
    pattern: /alíneas?\s+[a-z]/gi,
    category: 'geral',
    description: 'Subdivisão de inciso.'
  },
  {
    term: 'jurisprudência',
    pattern: /\bjurisprudência\b/gi,
    category: 'geral',
    description: 'Conjunto de decisões judiciais sobre determinada matéria.'
  },
  {
    term: 'súmula',
    pattern: /\bsúmulas?\b/gi,
    category: 'geral',
    description: 'Enunciado que resume entendimento do tribunal.'
  },
  {
    term: 'súmula vinculante',
    pattern: /súmula\s+vinculante/gi,
    category: 'constitucional',
    description: 'Súmula do STF de observância obrigatória.'
  }
]

/**
 * Categorias de termos jurídicos com cores
 */
export const CATEGORY_COLORS: Record<string, { bg: string; text: string; label: string }> = {
  processual: { bg: '#e3f2fd', text: '#1565c0', label: 'Processual' },
  penal: { bg: '#fce4ec', text: '#c62828', label: 'Penal' },
  civel: { bg: '#e8f5e9', text: '#2e7d32', label: 'Cível' },
  constitucional: { bg: '#fff3e0', text: '#e65100', label: 'Constitucional' },
  trabalhista: { bg: '#f3e5f5', text: '#7b1fa2', label: 'Trabalhista' },
  geral: { bg: '#eceff1', text: '#455a64', label: 'Geral' }
}

/**
 * Encontra todos os termos jurídicos em um texto
 */
export function findLegalTerms(text: string): { term: LegalTermDefinition; matches: RegExpMatchArray[] }[] {
  const results: { term: LegalTermDefinition; matches: RegExpMatchArray[] }[] = []

  for (const termDef of LEGAL_TERMS) {
    const pattern = new RegExp(termDef.pattern.source, termDef.pattern.flags)
    const matches: RegExpMatchArray[] = []
    let match: RegExpExecArray | null

    while ((match = pattern.exec(text)) !== null) {
      matches.push(match)
    }

    if (matches.length > 0) {
      results.push({ term: termDef, matches })
    }
  }

  return results
}

/**
 * Conta ocorrências de termos por categoria
 */
export function countTermsByCategory(text: string): Record<string, number> {
  const counts: Record<string, number> = {
    processual: 0,
    penal: 0,
    civel: 0,
    constitucional: 0,
    trabalhista: 0,
    geral: 0
  }

  const found = findLegalTerms(text)
  for (const { term, matches } of found) {
    counts[term.category] += matches.length
  }

  return counts
}
